import $ from "jquery"

export const initCookies = () => {
  $('body').on('click', '#cookieterms a#cookieterms-dismiss', (e)=> {
    e.preventDefault();
    $.get("/o/cookies_dismiss.json"
      , {}
      , function(result) {
        if (result.status_type == 'success') {
          $("#cookieterms").fadeOut(300, function() {
            $("html").addClass('cookieterms-dismissed');
          });
        }
    }, 'json');
  });
}